import { router } from "../router";
import { workspaceStore, WorkspaceType } from "../stores/workspaceStore";
import Cookies from 'js-cookie';

const LOGGED_IN_USER_KEY = 'fs3_logged_in_user';
const WS_COOKIE_NAME = 'fs3_selected_ws_id';

type SelectedWorkspaceSubscriber = (workspace: WorkspaceType | null) => void;

export const SelectedWorkspaceCtx = {
  selectedWorkspace: null as WorkspaceType | null,
  subscribers: [] as SelectedWorkspaceSubscriber[],

  // Add a subscriber
  subscribe(callback: SelectedWorkspaceSubscriber) {
    this.subscribers.push(callback);
    // Return an unsubscribe function
    return () => {
      this.unsubscribe(callback);
    };
  },

  // Remove a subscriber
  unsubscribe(callback: SelectedWorkspaceSubscriber) {
    this.subscribers = this.subscribers.filter(sub => sub !== callback);
  },

  // Notify all subscribers
  notifySubscribers() {
    this.subscribers.forEach(callback => callback(this.selectedWorkspace));
  },

  // prepare the workspace cookie name
  setWsKey() {
    const LOGGED_IN_USER = Cookies.get(LOGGED_IN_USER_KEY);
    return WS_COOKIE_NAME + (LOGGED_IN_USER ? '_' + LOGGED_IN_USER : '');
  },

  // Set the selected workspace and notify subscribers
  setSelectedWorkspace(workspace: WorkspaceType | null) {
    this.selectedWorkspace = workspace;

    Cookies.set(this.setWsKey(), workspace?.unique_workspace_id ?? "", { expires: 1000 }); // Store for 1000 days

    this.notifySubscribers();
  },

  isWorkspaceCookiePresent() {
    return Cookies.get(this.setWsKey()) ? true : false;
  },

  // load selected workspace from cookie
  loadSelectedWorkspace(workspaces: WorkspaceType[]) {
    const wsId = Cookies.get(this.setWsKey());
    if (!wsId) {
      if (window.location.pathname !== "/workspaces") {
        router.navigate("/workspaces");
      }
      return;
    }

    if (!workspaceStore?.firstFetch) {
      // if the workspaces are not yet fetched do nothing
      return;
    }

    const selectedWs = workspaceStore?.workspaces?.find(ws => ws.unique_workspace_id === wsId);

    if (selectedWs)
      this.setSelectedWorkspace(selectedWs);
    else {
      console.error("Selected workspace from cookie not present in the workspaces array");
      this.setSelectedWorkspace(workspaces[0]);
    }
  },

  // Clear the selected workspace and notify subscribers
  clearSelectedWorkspace() {
    this.selectedWorkspace = null;
    this.notifySubscribers();
    Cookies.remove(this.setWsKey());
  }
};
